'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var _style = require('./style');

var _ = require('./');

var AppBarStyles = _reactStyle2['default'].create({
  normalAppBarStyle: {
    backgroundColor: _style.Colors.cyan.P500,
    boxSizing: 'border-box',
    position: 'fixed',
    height: 56,
    top: 0,
    width: '100%',
    zIndex: '1'
  },

  expandedAppBarStyle: {
    height: 128,
    position: 'relative',
    marginTop: -128
  },

  navButtonStyle: {
    height: 26,
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    position: 'fixed',
    width: 24,
    display: 'inline-block',
    padding: '14px 16px',
    cursor: 'pointer',
    verticalAlign: 'top',
    top: 0
  },

  titleStyle: {
    display: 'inline-block',
    opacity: 'inherit',
    cursor: 'default',
    lineHeight: '56px',
    position: 'absolute',
    top: 0,
    left: 72
  },

  expandedTitleStyle: {
    position: 'relative',
    left: 14,
    top: 65
  },

  boxShadowStyle: {
    boxShadow: '0 2px 5px rgba(0, 0, 0, .26)'
  },

  placeHolderStyle: {
    backgroundColor: _style.Colors.cyan.P500,
    position: 'relative',
    height: 128,
    width: '100%'
  }
});

var _default = (function (_React$Component) {
  var _class = function _default(props) {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this, props);
    this.acceptingScrollValue = true;
    this.finalCheckTimeout = null;

    this.state = {
      scrollListenerAttached: false,
      showShadow: true
    };
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.initializeScrollListener();
      this.onBodyScroll();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.initializeScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onBodyScroll);
    }
  }, {
    key: 'initializeScrollListener',
    value: function initializeScrollListener() {
      if (typeof window === 'undefined') {
        return;
      }

      var expanded = this.props.expanded;
      var scrollListenerAttached = this.state.scrollListenerAttached;

      // fugly
      if (expanded && !scrollListenerAttached) {
        window.addEventListener('scroll', this.onBodyScroll.bind(this));
      } else if (!expanded && scrollListenerAttached) {
        window.removeEventListener('scroll', this.onBodyScroll.bind(this));
      }
    }
  }, {
    key: 'checkExpanded',
    value: function checkExpanded() {
      if (typeof window === 'undefined') {
        return;
      }
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      if (scrollTop > 30) {
        this.setState({ showExpanded: false });
      } else {
        this.setState({ showExpanded: true });
      }

      if (scrollTop >= 75) {
        this.setState({ showShadow: true });
      } else {
        this.setState({ showShadow: false });
      }

      this.scroll = false;

      if (this.finalCheckTimeout) {
        clearTimeout(this.finalCheckTimeout);
      }

      this.finalCheckTimeout = setTimeout(this.finalCheck.bind(this), 100);
    }
  }, {
    key: 'finalCheck',
    value: function finalCheck() {
      if (!this.scroll) {
        this.checkExpanded();
      }
    }
  }, {
    key: 'onBodyScroll',
    value: function onBodyScroll() {
      var _this = this;

      if (!this.acceptingScrollValue) {
        return;
      }
      this.scroll = true;

      this.checkExpanded();

      setTimeout(function () {
        _this.acceptingScrollValue = true;
      }, 100);

      this.acceptingScrollValue = false;
    }
  }, {
    key: 'renderPlaceHolder',
    value: function renderPlaceHolder(expanded, styles) {
      if (!expanded) {
        return null;
      }
      return _react2['default'].createElement('div', { styles: styles });
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle(title, _x, styles) {
      var onTitleClick = arguments[1] === undefined ? function () {} : arguments[1];

      if (!title) {
        return null;
      }
      return _react2['default'].createElement(
        'div',
        {
          onClick: function () {
            return onTitleClick();
          },
          styles: styles },
        title
      );
    }
  }, {
    key: 'renderBackButton',
    value: function renderBackButton(onBackButtonClick, styles) {
      if (!onBackButtonClick) {
        return null;
      }
      return this.renderIconWithClickHandler('arrow-back', onBackButtonClick, styles);
    }
  }, {
    key: 'renderMenuButton',
    value: function renderMenuButton(onNavButtonClick, styles) {
      if (!onNavButtonClick) {
        return null;
      }
      return this.renderIconWithClickHandler('menu', onNavButtonClick, styles);
    }
  }, {
    key: 'renderIconWithClickHandler',

    // NOTE(berks): This renderer may be abstracted to be used throughout the
    // project
    value: function renderIconWithClickHandler(icon, handleClick, styles) {
      return _react2['default'].createElement(
        'div',
        {
          onClick: function () {
            return handleClick();
          },
          styles: styles },
        _react2['default'].createElement(_.Icon, { icon: icon })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var defaultStyles = AppBarStyles;
      var propsStyles = this.props.styles;

      var _props = this.props;
      var children = _props.children;
      var expanded = _props.expanded;
      var onBackButtonClick = _props.onBackButtonClick;
      var onNavButtonClick = _props.onNavButtonClick;
      var onTitleClick = _props.onTitleClick;
      var shadow = _props.shadow;
      var title = _props.title;
      var _state = this.state;
      var showExpanded = _state.showExpanded;
      var showShadow = _state.showShadow;

      var appBarStyles = [defaultStyles.normalAppBarStyle, showExpanded && expanded && defaultStyles.expandedAppBarStyle];
      if (propsStyles) {
        appBarStyles = appBarStyles.concat(propsStyles.normalAppBarStyle);
      }

      if (shadow && !expanded || showShadow) {
        appBarStyles.push(defaultStyles.boxShadowStyle);
      }

      var expandedTitleStyle = undefined;
      var headLineStyle = undefined;

      if (showExpanded && expanded) {
        expandedTitleStyle = defaultStyles.expandedTitleStyle;
        headLineStyle = _style.Typography.headline;
      }

      var navButtonStyle = defaultStyles.navButtonStyle;

      var placeHolderStyles = [defaultStyles.placeHolderStyle, propsStyles.placeHolderStyle];
      var titleStyles = [_style.Typography.title, defaultStyles.titleStyle, expandedTitleStyle, headLineStyle, propsStyles.titleStyle];

      return _react2['default'].createElement(
        'div',
        null,
        this.renderPlaceHolder(expanded, placeHolderStyles),
        _react2['default'].createElement(
          'nav',
          { styles: [appBarStyles, propsStyles.appBarStyles] },
          this.renderMenuButton(onNavButtonClick, navButtonStyle),
          this.renderBackButton(onBackButtonClick, navButtonStyle),
          this.renderTitle(title, onTitleClick, titleStyles),
          children
        )
      );
    }
  }], [{
    key: 'displayName',
    value: 'AppBar',
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      styles: {}
    },
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      actionButtons: _react.PropTypes.array,
      boxShadow: _react.PropTypes.bool,
      children: _react.PropTypes.node,
      expanded: _react.PropTypes.bool,
      onBackButtonClick: _react.PropTypes.func,
      onNavButtonClick: _react.PropTypes.func,
      onTitleClick: _react.PropTypes.func,
      shadow: _react.PropTypes.bool,
      styles: _react.PropTypes.object,
      title: _react.PropTypes.string
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/AppBar.js
 ** module id = 168
 ** module chunks = 0
 **/